const setting = {
  setting: {
    selectedMenu: {},

    currentTab: 'scanner',
  },
};

export default setting;
